import { raiseError } from 'data/messages/messages.actions';
import getErrorMessageFromStatus from 'utils/getErrorMessageFromStatus';
import SupplierApi from './suppliers.api';
import supplierErrorMessages from './suppliers.errors';

export const LOAD_SUPPLIERS_START = Symbol('LOAD_SUPPLIERS_START');
export const LOAD_SUPPLIERS_SUCCESS = Symbol('LOAD_SUPPLIERS_SUCCESS');
export const LOAD_SUPPLIERS_ERROR = Symbol('LOAD_SUPPLIERS_ERROR');

const loadSuppliersStart = key => ({ type: LOAD_SUPPLIERS_START, key });
const loadSuppliersSuccess = (key, response) => ({ type: LOAD_SUPPLIERS_SUCCESS, key, response });
const loadSuppliersError = (key, error) => ({ type: LOAD_SUPPLIERS_ERROR, key, error });

export const LOAD_SWITCHSUPPLIER_START = Symbol('LOAD_SWITCHSUPPLIER_START');
export const LOAD_SWITCHSUPPLIER_SUCCESS = Symbol('LOAD_SWITCHSUPPLIER_SUCCESS');
export const LOAD_SWITCHSUPPLIER_ERROR = Symbol('LOAD_SWITCHSUPPLIER_ERROR');

const loadSwitchSupplierStart = key => ({ type: LOAD_SWITCHSUPPLIER_START, key });
const loadSwitchSupplierSuccess = (key, response) => ({ type: LOAD_SWITCHSUPPLIER_SUCCESS, key, response });
const loadSwitchSupplierError = (key, error) => ({ type: LOAD_SWITCHSUPPLIER_ERROR, key, error });

const raiseSupplierError = error => raiseError(new Error(getErrorMessageFromStatus(error.response.status, supplierErrorMessages)));

export function loadSuppliers(key) {
  return function loadSuppliersThunk(dispatch) {
    dispatch(loadSuppliersStart(key));
    SupplierApi.getSupplierDropDownList()
      .then(response => dispatch(loadSuppliersSuccess(key, response)))
      .catch((error) => {
        dispatch(raiseSupplierError(error));
        dispatch(loadSuppliersError(error));
      });
  };
}

export function switchToSupplier(key, supplierDropdownItem) {
  return function switchToSupplierThunk(dispatch) {
    dispatch(loadSwitchSupplierStart(key));
    SupplierApi.switchAccounts(supplierDropdownItem)
      .then(response => dispatch(loadSwitchSupplierSuccess(key, response)))
      .catch((error) => {
        dispatch(raiseSupplierError(error));
        dispatch(loadSwitchSupplierError(error));
      });
  };
}
